import { ListUsersV2CommandInput } from '@amzn/gbsa-orbit-typescript-client';

export const userKeys = {
  all: ['user'] as const,
  list: ({
    programId,
    businessUnit,
    division,
    isArchived,
    isUserActive,
    maxResults,
    nextToken,
    roleId,
  }: ListUsersV2CommandInput) =>
    [
      ...userKeys.all,
      'list',
      programId,
      businessUnit,
      division,
      isArchived,
      isUserActive,
      maxResults,
      nextToken,
      roleId,
    ] as const,
  details: ({
    businessUnit,
    programId,
    userAlias,
  }: {
    userAlias: string | undefined;
    programId: string | undefined;
    businessUnit: string | undefined;
  }) => [...userKeys.all, 'details', userAlias, programId, businessUnit] as const,
  metadata: ({
    userAlias,
    programId,
  }: {
    userAlias: string | undefined;
    programId: string | undefined;
  }) => [...userKeys.all, 'metadata', userAlias, programId] as const,
  programId: ({ programId }: { programId: string }) =>
    [...userKeys.all, 'programId', programId] as const,
  permissions: ({
    userAlias,
    programId,
    businessUnit,
    divisions,
  }: {
    userAlias: string | undefined;
    programId: string | undefined;
    businessUnit: string | undefined;
    divisions: string[] | undefined;
  }) =>
    [
      ...userKeys.all,
      'permissions',
      userAlias,
      programId,
      businessUnit,
      divisions,
    ] as const,
};
